import type { SendHoldCard } from '../../../../lib/send-hold';
import { HeldSendChips } from '../../send-hold/HeldSendChips';
import { FailedTurnRow } from './FailedTurnRow';

/**
 * The failed-turn row, plus the hold chips of a turn that failed AFTER it left a message waiting (send rule): the
 * hold is real whatever happened to the reply, so its Cancel stays under the failed row. Same on iOS/Android.
 */
export function FailedTurnWithHolds({
  messageId,
  onRetry,
  sendHoldCard,
  conversationId,
}: {
  messageId?: string;
  onRetry?: Parameters<typeof FailedTurnRow>[0]['onRetry'];
  sendHoldCard?: SendHoldCard;
  conversationId?: string;
}) {
  return (
    <>
      <FailedTurnRow messageId={messageId} onRetry={onRetry} />
      {sendHoldCard ? <HeldSendChips card={sendHoldCard} conversationId={conversationId} /> : null}
    </>
  );
}
